import { useNavigate } from "react-router-dom";
import PrevIcon from "../images/PrevIcon";

const PrevButton = () => {
  const navigate = useNavigate();

  return (
    <button onClick={() => navigate(-1)}>
      <PrevIcon />
    </button>
  );
};

export default PrevButton;
